import { ButtonBrand } from 'components/ButtonBrand';
import { Body, Eyebrow, H4 } from 'components/Typography';
import {
  ConfirmationBackgroundContainer,
  ConfirmationButtonRow,
  ConfirmationCardContainer,
  ConfirmationContainer,
  ConfirmationContainerLeft,
  ConfirmationImage,
  ProcessingCardContent,
  ProcessingImage,
} from './styled';
import theme from 'config/theme';
import Spacing from 'components/Spacing';
import { scrollToTop } from 'helpers/utils';
import { FC, useEffect } from 'react';
import { useAppSelector } from 'helpers/hooks';
import { getPayData, getPayDafData } from 'selectors/pay';
import { PopupModal } from 'components/PopupModal';
import { checkoutLogFirebaseEvent } from 'screens/Checkout/Form/utils';
import { useShareUrl } from 'hooks/useShareUrl';
import { getUserState } from 'selectors/user';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { ProfileCard } from 'components/Cards/ProfileCard';
import { trackPixel } from 'helpers/pixel';
import { ENV_CONFIG } from 'config/environment';
import { Link } from 'components/Link';
interface Props {
  candidates: CandidateType[];
  donationAmount: number;
  isEvent: boolean;
  pageImage: string;
}

export const Confirmation: FC<Props> = ({ candidates, donationAmount, isEvent, pageImage }) => {
  const { payment, userState, dafPayment } = useAppSelector(state => ({
    payment: getPayData(state),
    userState: getUserState(state),
    dafPayment: getPayDafData(state),
  }));
  const { isPopupOpen } = useShareUrl(userState?.data?.ref_code);
  const textColor = dafPayment || !isEvent ? theme.colors.inkBlue : theme.colors.white;
  const headerBackground = dafPayment
    ? theme.colors.inkBlue
    : isEvent
    ? theme.colors.oathBlue
    : undefined;

  const handleGoHome = () => {
    window.location.href = `/donate${window.location.search}`;
    return null;
  };

  if (!payment && !dafPayment) {
    handleGoHome();
  }

  useEffect(() => {
    scrollToTop();
    trackPixel('purchase');
    trackPixel('universalPixel');
    checkoutLogFirebaseEvent({
      eventName: 'view_confirmation',
      userId: userState?.data?.id || '',
      candidates,
      donationAmount,
    });
  }, []);

  return (
    <>
      <ConfirmationBackgroundContainer
        $backgroundColor={
          dafPayment ? theme.colors.softGray : isEvent ? theme.colors.inkBlue : undefined
        }
      >
        <ConfirmationContainer>
          <ConfirmationContainerLeft>
            <Eyebrow $color={textColor}>Donation initiated</Eyebrow>
            <Spacing $size={5} />
            <H4 $color={textColor}>Your grant has been initiated</H4>
            <Spacing $size={5} />
            <Body $color={textColor}>
              This grant request has been sent to your financial institution and will be processed
              according to their procedures.
            </Body>
            {pageImage && <ConfirmationImage alt="Donate page logo" src={pageImage} />}
            <ConfirmationButtonRow>
              <ButtonBrand onClick={handleGoHome}>Go to Home</ButtonBrand>
            </ConfirmationButtonRow>
          </ConfirmationContainerLeft>
          <ConfirmationCardContainer>
            <ProfileCard
              title="Pending Authorization Status"
              align="center"
              smallTitle={true}
              headerBackground={headerBackground}
            >
              <ProcessingCardContent>
                <ProcessingImage
                  src={`${
                    ENV_CONFIG().CLOUD_STORAGE.URL
                  }/static_content/misc_icons/circle_arrows.png`}
                  alt="Circle formed by two arrows"
                />
                <Body>
                  This donation has been initiated as a grant request from your donor advised fund.
                </Body>
                <br />
                <Body>
                  If you have questions on the status of this grant, please reach out to your
                  financial institution directly.
                </Body>
                <br />
                <Link href="/" $textAlign="center" $color={theme.colors.gray}>
                  View contribution history
                </Link>
              </ProcessingCardContent>
            </ProfileCard>
          </ConfirmationCardContainer>
          <PopupModal autoClose={true} isSelected={isPopupOpen} title="Copied to Clipboard" />
        </ConfirmationContainer>
      </ConfirmationBackgroundContainer>
    </>
  );
};
